// extracted by mini-css-extract-plugin
module.exports = {"cartPageAsideInfoLine":"aside-info-line_cartPageAsideInfoLine__V1Dsg","cartPageAsideInfoLineRight":"aside-info-line_cartPageAsideInfoLineRight__ncxra"};